import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
    Legend,
    Filler,
    Chart,
    ChartData,
} from 'chart.js';
import { useRef } from 'react';
import { StatisticLineChartData, StatusType } from '../types/statistics.types';
import './line-chart.scss';


ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);


interface LineChartProps {
    datasets: StatisticLineChartData[];
}

const LineChart: React.FC<LineChartProps> = ({ datasets }) => {

    const labels = datasets[0]?.values.map(v => v.date) || [];
    const chartRef = useRef<Chart<'line'> | null>(null);

    const chartData: ChartData<'line', number[], string> = {
        labels,
        datasets: datasets.map(ds => ({
            data: ds.values.map(v => v.transactionNo),
            borderColor: (context: any) => {
                const { chartArea, ctx } = context.chart;
                if (!chartArea) return null;
                const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                gradient.addColorStop(0, ds.colors[0]);
                gradient.addColorStop(1, ds.colors[1]);
                return gradient;
            },
            borderWidth: 2,
            fill: true,
            backgroundColor: (context: any) => {
                const { chartArea, ctx, dataset } = context.chart;
                if (!chartArea) return null;
                const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                gradient.addColorStop(0, ds.colors[0]);
                gradient.addColorStop(1, ds.colors[1]);
                return gradient;
            },
            pointRadius: 0,
            tension: 0,
        }))
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                type: 'category' as const,
                ticks: {
                    color: 'black',
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: '#FFF',
                },
                grid: { display: false }
            }
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'index' as const,
                intersect: false
            },
            datalabels: {
                display: false,
            },

        }
    };

    return (
        <div className='line-chart-container'>
            <div className='line-chart'>
                <Line
                    ref={(el) => {
                        if (el) {
                            chartRef.current = (el as any).chartInstance;
                        } else {
                            chartRef.current = null;
                        }
                    }}
                    data={chartData}
                    options={options}
                />
            </div>
        </div>
    );
};

export default LineChart;
